export const frequencyOptions = ['Multiple times a day', 'Daily', 'Weekly', 'Monthly', 'Less than once a month']
